/// <reference path="../../../scripts/typings/Nema.Crew.Model.d.ts" />

import { Injectable, Inject } from '@angular/core';

import service = require("./breeze.entitymanager.service");
import base = require("./base.dataservice");

export function initialize(module: ng.IModule) {
    module.service(WorkplaceDataService.Id, WorkplaceDataService);

    WorkplaceDataService.$inject = ["entityManagerService", "breeze", "$log", "$q"];
}

@Injectable()
export class WorkplaceDataService extends base.BaseDataService<Nema.Crew.Model.Workplace> implements IWorkplaceDataService {

    constructor(
        @Inject("entityManagerService") entityManagerService: service.EntityManagerService,
        @Inject("breeze") breeze,
        @Inject("$log") $log,
        @Inject("$q") $q: ng.IQService) {
        super(entityManagerService, breeze, $log, $q);
    }

    public static Id = "workplaceDataService";

    public get EntityName(): string {
        return "Workplace";
    }

    public get EntitiesName(): string {
        return "Workplaces";
    }
}

export interface IWorkplaceDataService extends base.IDataService<Nema.Crew.Model.Workplace> {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/workplaces.dataservice.ts